import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const features = ['Rutinas simples', 'Hábitos saludables', 'Motivación real', 'Alimentación inteligente', 'Disciplina', 'Bienestar mental', 'Energía diaria', 'Organización', 'Constancia', 'Transformación total'];
export function ProductIntro() {
  return <section className="py-12 md:py-24 px-4 relative overflow-hidden" data-id="element-170">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] md:w-[800px] h-[500px] md:h-[800px] bg-brand-500/10 blur-[100px] rounded-full pointer-events-none" data-id="element-171" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-172">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-173">
          <div className="text-brand-500 font-bold tracking-widest uppercase text-[10px] md:text-sm mb-2 md:mb-4" data-id="element-174">
            SISTEMA N°1 PARA TRANSFORMARTE DESDE CASA
          </div>

          <h2 className="text-5xl md:text-8xl font-bebas text-white mb-2" data-id="element-175">
            ENTRENA EN CASA™
          </h2>

          <div className="text-sm md:text-2xl text-zinc-300 font-medium mb-6 md:mb-10" data-id="element-176">
            Sistema Completo · 6 Tomos + 3 Bonus
          </div>

          <div className="flex flex-wrap justify-center gap-1.5 md:gap-3 mb-6 md:mb-10" data-id="element-177">
            {features.map((feature, i) => <motion.div key={i} initial={{
            opacity: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.04
          }} whileHover={{
            scale: 1.05,
            borderColor: 'rgb(249 115 22)'
          }} className="flex items-center gap-1.5 bg-zinc-900 border border-zinc-800 px-3 py-1 md:px-4 md:py-2 rounded-full text-xs md:text-sm text-zinc-300" data-id="element-178">
                <Check className="w-3 h-3 md:w-4 md:h-4 text-brand-500" data-id="element-179" />
                {feature}
              </motion.div>)}
          </div>

          <div className="inline-block bg-zinc-900/80 border border-zinc-800 px-4 py-2 md:px-6 md:py-3 rounded-xl text-zinc-300 font-medium text-xs md:text-base" data-id="element-180">
            🏠 Funciona desde hoy en tu casa, patio o habitación.
          </div>
        </motion.div>
      </div>
    </section>;
}